export default function Artists() {
  const artists = [
    {
      name: '山田 太郎',
      genre: 'ロック',
      image: 'https://public.readdy.ai/ai/img_res/b68a599b28b3a42582add1c7c8dcf648.jpg',
      description: '力強いボーカルと情熱的なギタープレイで観客を魅了する実力派ロックアーティスト。'
    },
    {
      name: '佐藤 花子',
      genre: 'ジャズ',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20female%20jazz%20vocalist%20portrait%20in%20her%2020s%2C%20elegant%20studio%20photography%20with%20soft%20lighting%20and%20neutral%20background%2C%20sophisticated%20and%20artistic%20expression%2C%20professional%20music%20artist%20headshot&width=400&height=400&seq=artist-002&orientation=squarish',
      description: '透明感のある歌声と豊かな表現力で、ジャズの魅力を伝えるシンガー。'
    },
    {
      name: 'THE TOKYO BEATS',
      genre: 'ポップ',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20pop%20music%20band%20group%20photo%20with%204%20members%2C%20studio%20photography%20with%20modern%20lighting%20and%20neutral%20background%2C%20energetic%20and%20friendly%20expressions%2C%20contemporary%20band%20portrait&width=400&height=400&seq=artist-003&orientation=squarish',
      description: 'キャッチーなメロディーと洗練されたサウンドで人気急上昇中の4人組バンド。'
    },
    {
      name: '鈴木 健一',
      genre: 'フォーク',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20male%20folk%20musician%20portrait%20in%20his%2040s%20with%20acoustic%20guitar%2C%20warm%20studio%20photography%20with%20soft%20lighting%20and%20neutral%20background%2C%20gentle%20and%20thoughtful%20expression%2C%20professional%20music%20artist%20headshot&width=400&height=400&seq=artist-004&orientation=squarish',
      description: '心に響く歌詞と優しいギターの音色で、聴く人の心を癒すフォークシンガー。'
    },
    {
      name: 'DJ TOKYO NIGHT',
      genre: 'エレクトロニック',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20DJ%20portrait%20in%20his%2030s%20with%20headphones%2C%20modern%20studio%20photography%20with%20cool%20lighting%20and%20neutral%20background%2C%20creative%20and%20energetic%20expression%2C%20professional%20music%20artist%20headshot&width=400&height=400&seq=artist-005&orientation=squarish',
      description: '最先端のエレクトロニックサウンドで、フロアを熱狂させるトップDJ。'
    },
    {
      name: '田中 美咲',
      genre: 'シンガーソングライター',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20female%20singer-songwriter%20portrait%20in%20her%2020s%20with%20acoustic%20guitar%2C%20natural%20studio%20photography%20with%20warm%20lighting%20and%20neutral%20background%2C%20sincere%20and%20artistic%20expression%2C%20professional%20music%20artist%20headshot&width=400&height=400&seq=artist-006&orientation=squarish',
      description: '自身の経験を綴った楽曲で、多くの共感を呼ぶシンガーソングライター。'
    },
    {
      name: 'URBAN GROOVE',
      genre: 'R&B/ソウル',
      image: 'https://readdy.ai/api/search-image?query=Professional Japanese R&B soul music group photo with 3 members, stylish studio photography with warm lighting and neutral background, cool and sophisticated expressions, contemporary band portrait&width=400&height=400&seq=artist-007&orientation=squarish',
      description: 'グルーヴィーなリズムと洗練されたハーモニーが魅力の3人組ユニット。'
    },
    {
      name: '伊藤 誠',
      genre: 'ブルース',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20male%20blues%20guitarist%20portrait%20in%20his%2050s%2C%20classic%20studio%20photography%20with%20dramatic%20lighting%20and%20neutral%20background%2C%20experienced%20and%20soulful%20expression%2C%20professional%20music%20artist%20headshot&width=400&height=400&seq=artist-008&orientation=squarish',
      description: '長年の経験から生まれる深みのあるブルースギターで、観客を魅了するベテラン。'
    }
  ];

  return (
    <section id="artists" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">登録アーティスト</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            東京クラブには、様々なジャンルの才能あふれるアーティストが登録しています。
            新人からベテランまで、それぞれの個性と魅力を持ったアーティストたちが活躍しています。
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {artists.map((artist, index) => (
            <div key={index} className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-shadow">
              <div className="w-full h-64">
                <img 
                  src={artist.image} 
                  alt={artist.name}
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <div className="p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-2">{artist.name}</h3>
                <div className="inline-block px-3 py-1 bg-gray-900 text-white text-xs rounded-full mb-3 whitespace-nowrap">
                  {artist.genre}
                </div>
                <p className="text-sm text-gray-600 leading-relaxed">{artist.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}